<template>
    <div class="login-container">
        <div class="login-left">
            <img src="/img/login-img.jpg" class="login-img">
        </div>

        <div class="login-right">
            <div class="login-card">
                <el-form class="login-form" :model="loginInfo" :rules="formRules" ref="loginForm">
                    <div class="form-label">
                        <div class="form-label-icon"><img src="/img/login-username.png"></div>
                        <div class="form-label-text">账号</div>
                    </div>
                    <el-form-item prop="username">
                        <el-input v-model="loginInfo.username" :placeholder="$t('shopLogin.usernamePlaceholder')" maxlength="20"
                                  autocomplete="off" autofocus @keyup.enter.native="doLogin" class="custom-input">
                        </el-input>
                    </el-form-item>
                    <div class="form-label">
                        <div class="form-label-icon"><img src="/img/login-password.png"></div>
                        <div class="form-label-text">密码</div>
                    </div>
                    <el-form-item prop="passwd">
                        <el-input v-model="loginInfo.passwd" type="password" :placeholder="$t('shopLogin.passwordPlaceholder')"
                                  maxlength="20" autocomplete="off" @keyup.enter.native="doLogin" class="custom-input">
                        </el-input>
                    </el-form-item>
                    <div class="form-label">
                        <div class="form-label-icon"><img src="/img/login-captcha.png"></div>
                        <div class="form-label-text">验证码</div>
                    </div>
                    <el-form-item prop="validateCode" class="captcha-item">
                        <div class="captcha-container">
                            <el-input v-model="loginInfo.validateCode" :placeholder="$t('shopLogin.codePlaceholder')" maxlength="6"
                                      autocomplete="off" @keyup.enter.native="doLogin" class="custom-input">
                            </el-input>
                            <div class="code-wrapper">
                                <img :src="loginInfo.codeImage" :alt="$t('shopLogin.refreshCode')" class="code-image"
                                     @click="generateCode" v-if="loginInfo.codeImage">
                                <div v-else class="code-loading">
                                    <i class="el-icon-loading"></i>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="loginLoading" @click="doLogin">
                            <span v-if="!loginLoading">{{ $t('shopLogin.signIn') }}</span>
                            <span v-else>{{ $t('shopLogin.signingIn') }}</span>
                        </el-button>
                    </el-form-item>
                </el-form>
                <!-- 底部链接 -->
                <div class="login-footer">
                    <p class="register-text">
                        {{ $t('shopLogin.noAccount') }}
                        <a href="javascript:void(0)" @click="_doRegister" class="register-link">
                            {{ $t('shopLogin.register') }}
                        </a>
                    </p>
                </div>
            </div>
        </div>


        <!-- 初始化数据组件 -->
        <init-data ref="initData"></init-data>
    </div>
</template>

<script>
import { getSysInfo, pcUserLogin, generatorValidateCode } from '@/api/frame/loginApi'
import InitData from '@/components/frame/initData/initData'

export default {
  name: 'Login',
  components: {
    InitData
  },
  data() {
    return {
      loginLoading: false,
      loginInfo: {
        logo: '',
        username: '',//18909711443
        passwd: '',
        validateCode: '',
        errorInfo: '',
        codeImage: '',
        systemTitle: ''
      },
      formRules: {
        username: [
          { required: true, message: this.$t('shopLogin.usernameRequired'), trigger: 'blur' },
          { min: 3, max: 20, message: this.$t('shopLogin.usernameLength'), trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: this.$t('shopLogin.passwordRequired'), trigger: 'blur' },
          { min: 5, max: 20, message: this.$t('shopLogin.passwordLength'), trigger: 'blur' }
        ],
        validateCode: [
          { required: true, message: this.$t('shopLogin.codeRequired'), trigger: 'blur' },
          { len: 4, message: this.$t('shopLogin.codeLength'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.clearCacheData()
    this._loadSysInfo()
    this.generateCode()
  },
  methods: {
    clearCacheData() {
      localStorage.clear()
      sessionStorage.clear()
    },
    async _loadSysInfo() {
      try {
        const res = await getSysInfo({ sys: 'HC' })
        Object.assign(this.loginInfo, res)
        localStorage.setItem('_sysInfo', JSON.stringify(res))
      } catch (error) {
        console.log("加载系统信息失败", error)
        localStorage.setItem('_sysInfo', JSON.stringify({ logo: 'HC' }))
        this.loginInfo.errorInfo = error.message
      }
    },
    async doLogin() {
      try {
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return

        this.loginLoading = true
        const res = await pcUserLogin(this.loginInfo)

        if (res.code && res.code !== '0') {
          this.$message.error(res.msg)
          this.generateCode() // 刷新验证码
          return
        }

        localStorage.setItem('token', res.token)

        this.$message.success(this.$t('shopLogin.loginSuccess'))
        this.$refs.initData.loadShopInfo({ url: '/views/index/index' })
      } catch (error) {
        this.$message.error(error.message || this.$t('shopLogin.loginFailed'))
        this.loginInfo.errorInfo = error.message
        this.generateCode() // 刷新验证码
      } finally {
        this.loginLoading = false
      }
    },
    _doRegister() {
      this.$router.push('/pages/frame/register')
    },
    async generateCode() {
      try {
        const res = await generatorValidateCode({ _uId: '123' })
        this.loginInfo.codeImage = res
      } catch (error) {
        console.log('请求验证码失败', error)
      }
    }
  },
  beforeDestroy() {
    console.log("登录页面销毁调用")
  }
}
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.login-left{
    display: flex;
    height: 100%;
}
.login-img{
    height: 100%;
}
.login-right{
    flex: 1; display: flex; justify-content: center; align-items: center;
}
.login-card {
    width: 325px;
    max-width: 80%;
    margin-right: 15%;
    /*width: 300px;*/
    /*padding: 20px;*/
    /*background-color: rgba(0, 0, 0, 0.5);*/
    /*border-radius: 4px;*/
    /*position: absolute;*/
    /*left: 50%;*/
    /*top: 35%;*/
    /*margin: -150px 0 0 -150px;*/
    /*z-index: 99;*/
    text-align: center;
    /*padding: 30px;*/
    /*box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);*/
}
.form-label{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
}
.form-label-icon{ width: 20px; height: 20px; margin-right: 5px; }
.form-label-icon img{ width: 20px;}
.el-form-item :deep(.el-input__inner){
    border-color: transparent;
    background-color: rgba(239, 50, 28, 0.08);
    outline-color: transparent;
}

.login-card .login-title {
    color: #fff;
    text-align: center;
    font-size: 48px;
}

.el-form-item {
    margin-bottom: 20px;
}

.el-input__inner {
    background: #fff;
    border: none;
    border-radius: 5px;
    color: #333;
    height: 40px;
}

.captcha-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.captcha-item .el-input {
    width: 70%;
    height: 38px;
    line-height: 1.3;
}

.captcha-img {
    height: 40px;
    cursor: pointer;
    border-radius: 5px;
}

.code-wrapper {
  /*position: absolute;*/
  /*right: 5px;*/
  /*top: 50%;*/
  /*transform: translateY(-50%);*/
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.code-wrapper:hover {
  transform: scale(1.05);
}

.code-image {
  width: 100px;
  height: 40px;
  display: block;
}

.code-loading {
  width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  color: #9ca3af;
}


.login-footer {
  text-align: center;
}

.register-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.register-link {
  color: #ee3111;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.register-link:hover {
  color: #ee3111;
  text-decoration: underline;
}

.el-button--primary {
    width: 100%;
    background: linear-gradient(90deg, #ff6247, #ee3111) !important;
    border: none;
    border-radius: 100px;
    font-size: 14px;
    height: 38px;
}

.el-button--primary:hover {
    opacity: 0.8;
    color: #fff;
}

</style>